import React, {useEffect} from 'react';
import './styles/careerintern.css';
import {useNavigate} from "react-router-dom";  // If you're using React Router for navigation
import {useForm} from 'react-hook-form';
import 'react-bootstrap';

function CareerIntern() {
    useEffect(() => {
        document.documentElement.scrollTop = 0;
    });

    // ----------------------------------------------------------------------------------------------------------------------------

    const {register, handleSubmit, formState: {errors}, reset} = useForm();


    async function onSubmit(data) {
        try {
            if (data.linkedIn_profile === undefined) {
                data.linkedIn_profile = "";
            }
            if (data.skills_and_experience === undefined) {
                data.skills_and_experience = "";
            }
            if (data.additional_information === undefined) {
                data.additional_information = "";
            }

            const formUrl = 'https://docs.google.com/forms/d/1gXYHblJXmsJRum9p_XWTcudsN6qDqdK_WGN4dtDtTV8/formResponse';
            const params = {
                'entry.1781500597': data.firstName,
                'entry.392094968': data.lastName,
                'entry.1640447617': data.email,
                'entry.297979220': data.phone_number,
                'entry.1616303377': data.linkedin_profile,
                'entry.215490742': data.skills_and_experience,
                'entry.760257932': data.additional_information,
                'entry.2040870261': data.cover_letter
            };
            const queryString = new URLSearchParams(params).toString();

            // Send a POST request using fetch API without redirecting
            await fetch(formUrl + '?' + queryString, {
                method: 'POST',
                mode: 'no-cors', // Use 'no-cors' mode to prevent CORS issues
            });

            console.log(data.firstName)

            const mailtoLink = `mailto:careers@inouttek.com?subject=Student Internship &body= Hi I am  ${encodeURIComponent(data.firstName)} ${encodeURIComponent(data.lastName)} %0A%0AEmail : ${encodeURIComponent(data.email)} %0APhone Number : ${encodeURIComponent(data.phone_number)} %0ALinkedIn Profile : ${encodeURIComponent(data.linkedin_profile)} %0ASkills and Experience ${encodeURIComponent(data.skills_and_experience)} %0AAdditional Information : ${encodeURIComponent(data.additional_information)} %0ACover Letter : ${encodeURIComponent(data.cover_letter)} %0A%0A Please Attach Your Resume`;
            window.location.href = mailtoLink;

            reset();


            setTimeout(() => {
                // window.location.reload();
                reset();
            }, 1000);
        } catch (error) {
            console.log(error.message);

            console.log("Error")
        }
    }


    //-------------------------------------------------------------------------------------------------------------------------------
    const backgroundImage = "/images/Career/careerImage.jpg";
    return (
        <>
            <h1 className='careerInternTitle'>Student Intern</h1>
            <div className={"text-start p-2 ps-4"}>

            </div>

            <div className="CareerBackgroundImage" style={{
                backgroundImage: `url(${backgroundImage})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                position: 'absolute',
                height: "100%",
                width: "100%",
                opacity: "0.1",
            }}>

            </div>

            <div className="careerContainer" style={{position: "relative"}}>
                <div className="content m-2">
                    <h4>Qualifications and Requirements – Freshers</h4>
                    <p>At InOutTek Solutions, we are passionate about empowering fresh talent and helping you grow in
                        the
                        world
                        of software development and DevOps. We’re looking for motivated individuals who are eager to
                        learn,
                        adapt, and build a strong foundation in the tech industry.</p>

                    <h4> Educational Qualifications:</h4>
                    <ul>
                        <li>Bachelor’s degree in Computer Science, Information Technology, Electronics, or a related
                            field (B.E/B.Tech/B.Sc/BCA/MCA/M.Sc).
                        </li>
                        <li>Final-year students or recent graduates are welcome to apply.</li>
                    </ul>

                    <h4> Technical Skills (Basic Knowledge Required):</h4>
                    <ul>
                        <li>Programming fundamentals in one or more languages (Python, Java, etc.).</li>
                        <li>Basic understanding of web technologies (HTML, CSS, JavaScript) for Full Stack roles.</li>
                        <li>Familiarity with Linux commands and shell scripting.</li>
                        <li>Basic understanding of software development lifecycle (SDLC).</li>
                        <li>Awareness of cloud concepts (AWS, Azure, or GCP) is a plus.</li>
                        <li>For DevOps roles: basic knowledge of CI/CD, Git, Docker is desirable.</li>
                        <li>For Testing/Automation: basic concepts of software testing and any scripting language is a
                            plus.
                        </li>
                    </ul>


                    <h4> Other Requirements:</h4>
                    <ul>
                        <li>Availability for full-time internship or trainee programs (onsite or remote depending on the
                            role).
                        </li>
                        <li>Commitment to completing training assignments and project work.</li>
                        <li>A growth mindset with a passion for building a career in IT.</li>
                    </ul>
                </div>

                <div className="careerForm">
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div className="careerFormInput">
                            <div className="careername">
                                <div className="careerfirstname">
                                    <input
                                        type="text"
                                        name="firstName"
                                        id="firstName"
                                        placeholder="First Name *"
                                        {...register('firstName', {required: 'First Name is required'})}
                                    />
                                    {errors.firstName && <span style={{
                                        color: 'red',
                                        justifyContent: "start",
                                        display: "flex"
                                    }}>{errors.firstName.message}</span>}

                                </div>
                                <div className="careerlastname">
                                    <input
                                        type="text"
                                        name="lastName"
                                        id="lastName"
                                        placeholder="Last Name *"
                                        {...register('lastName', {required: 'Last Name is required'})}
                                    />
                                    {errors.lastName && <span style={{
                                        color: 'red',
                                        justifyContent: "start",
                                        display: "flex"
                                    }}>{errors.lastName.message}</span>}

                                </div>
                            </div>


                        </div>

                        <div className="careerFormInput">
                            <input
                                type="email"
                                name="email"
                                id="email"
                                placeholder="E-mail *"
                                {...register('email', {
                                    required: 'Email is required',
                                    pattern: {
                                        value: /^\S+@\S+\.\S+$/,
                                        message: 'Invalid email format'
                                    }
                                })}
                            />
                            {errors.email && <span style={{
                                color: 'red',
                                justifyContent: "start",
                                display: "flex"
                            }}>{errors.email.message}</span>}
                        </div>

                        <div className="careerFormInput">
                            <input
                                type="text"
                                name="phone_number"
                                id="phone_number"
                                placeholder="Phone Number *"
                                {...register('phone_number', {
                                    required: 'Mobile number is required',
                                    pattern: {
                                        value: /^[0-9]{10}$/,
                                        message: 'Invalid mobile number. Must be 10 digits.'
                                    }
                                })}
                            />
                            {errors.phone_number && <span style={{
                                color: 'red',
                                justifyContent: "start",
                                display: "flex"
                            }}>{errors.phone_number.message}</span>}
                        </div>


                        <div className="careerFormInput">
                            <input
                                type="text"
                                name="linkedin_profile"
                                id="linkedin_profile"
                                placeholder="LinkedIn Profile "
                                {...register('linkedin_profile')}
                            />
                        </div>
                        <div className="careerFormInput">
                            <input
                                type="text"
                                name="skills_and_experience"
                                id="skills_and_experience"
                                placeholder=" Skills and Experience "
                                {...register('skills_and_experience')}
                            />
                        </div>
                        <div className="careerFormInput">
                            <input
                                type="text"
                                name="additional_information"
                                id="additional_information"
                                placeholder="Additional Information"
                                {...register('additional_information')}
                            />
                        </div>
                        <div className="careerFormInput">
                            <textarea
                                type="text"
                                name="cover_letter"
                                id="cover_letter"
                                placeholder="Cover Letter *"
                                {...register('cover_letter', {required: 'Cover Letter is required'})}
                            ></textarea>
                            {errors.cover_letter && <span style={{
                                color: 'red',
                                justifyContent: "start",
                                display: "flex"
                            }}>{errors.cover_letter.message}</span>}

                        </div>

                        {/* <div className="careerFormInput">
                            <div class="upload-resume">

                                <button class="resumeButton ">Upload Resume *</button>
                                <input
                                    type="file"
                                    name="resume"
                                    id="resume"
                                // {...register('resume', { required: 'Resume is required' })}
                                />
                                {errors.resume && <span style={{ color: 'red', justifyContent: "start", display: "flex" }}>{errors.resume.message}</span>}
                            </div>
                        </div> */}
                        <div className="careerFormInput">
                            <button type="submit" className='submitButton'>Submit</button>

                        </div>
                    </form>
                </div>
            </div>
        </>
    )
}

export default CareerIntern;